var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("p", { staticClass: "badge badge-info" }, [
      _vm._v(
        "Задача на изменение цены/активности (" + _vm._s(_vm.task.id) + ")"
      ),
    ]),
    _vm._v(" "),
    _c(
      "table",
      { staticClass: "table table-sm mt-1" },
      [
        _vm._l(_vm.getMainChanges(), function (t) {
          return _c("tr", [
            _c("td", [
              _vm._v(_vm._s(_vm.$AllProjects[t.project_id].title)),
              t.qty > 1
                ? _c("span", [_vm._v(" от " + _vm._s(t.qty) + " шт.")])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(_vm._s(t.price) + " (" + _vm._s(t.taskProfit) + " %)"),
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(t.actualPrice) + " (" + _vm._s(t.actualProfit) + " %)"
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _vm.newDiffRecords && _vm.newDiffRecords.projects
          ? _c("tr", [
              _c("td", { attrs: { colspan: "10" } }, [
                _vm._v("Добавлены дифф цены "),
                _c("strong", [_vm._v(_vm._s(_vm.newDiffRecords.projects))]),
              ]),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }